export {default as path} from "./path.js";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-path/src/index.js
// module id = null
// module chunks = 